module.exports = __webpack_public_path__ + "936864bd43cccc22e214c2a60e2548c2.svg";